import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar"; // Путь для нового Navbar

import Sidebar from "./Sidebar"; // Подключаем Sidebar
import MainContainer from "../MainContainer"; // Подключаем контейнер для контента

function Layout({ children }) {
  const location = useLocation(); // Список путей, где не нужно показывать Navbar и Sidebar
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    if (window.innerWidth < 760) return true;
    const saved = window.localStorage.getItem("crmSidebarCollapsed");
    if (saved !== null) return saved === "true";
    return window.innerWidth < 1000;
  });
  useEffect(() => {
    const closeOnSmallScreen = () => { if (window.innerWidth < 760) setSidebarCollapsed(true); };
    window.addEventListener('resize', closeOnSmallScreen);
    return () => window.removeEventListener('resize', closeOnSmallScreen);
  }, []);
  const excludeLayoutPaths = [
    "/",
    "/register-founder",
    "/login",
    "/register-admin",
    "/login-admin",
    "/admin-panel",
  ];

  // Определяем, показывать ли Navbar и Sidebar
  const showLayout = !excludeLayoutPaths.includes(location.pathname);

  return (
    <div
      className={`erp-workspace${sidebarCollapsed ? " is-collapsed" : ""}`}
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      {showLayout && <Navbar />}
      <div
        style={{
          display: "flex",
          flex: 1,
          marginTop: showLayout ? "72px" : "0", // Отступ под фиксированный Navbar
          marginLeft: showLayout ? (sidebarCollapsed ? "72px" : "244px") : "0",
          transition: "margin-left 180ms ease",
          minWidth: 0,
        }}
      >
        {showLayout && (
          <Sidebar
            collapsed={sidebarCollapsed}
            onToggle={() => {
              setSidebarCollapsed((current) => {
                const next = !current;
                window.localStorage.setItem("crmSidebarCollapsed", String(next));
                return next;
              });
            }}
          />
        )}
        <MainContainer>{children}</MainContainer>{" "}
        {/* Контент отображается здесь */}
      </div>
    </div>
  );
}

export default Layout;
